import React from 'react';

import AmazonWebServicesContainer from '@totem/components/administration/amazonWebServices/AmazonWebServicesContainer';
import AmazonWebServicesLayout, {
  AmazonWebServicesExtra,
} from '@totem/components/administration/amazonWebServices/AmazonWebServicesLayout';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';

const AmazonWebServicesPage = () => (
  <ContentLayout>
    <AmazonWebServicesContainer>
      <IBCard
        isCovered
        title="Amazon Web Services"
        extra={<AmazonWebServicesExtra />}
      >
        <AmazonWebServicesLayout />
      </IBCard>
    </AmazonWebServicesContainer>
  </ContentLayout>
);

export default AmazonWebServicesPage;
